import React from "react";
import { useTranslation } from "react-i18next";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";
import { EMPTY_VALUE_DASH } from "src/constants";

interface Props {
    term: number;
    paymentType: string;
}

const Term = ({ term, paymentType }: Props) => {
    const { t } = useTranslation();

    if (paymentType === "cash") {
        return null;
    }

    return (
        <Row>
            <LabelColumn>{t("ContinueDeal.VehicleInfo.termLabel")}</LabelColumn>
            <ValueColumn>{term ? `${term} ${t("ContinueDeal.VehicleInfo.months")}` : EMPTY_VALUE_DASH}</ValueColumn>
        </Row>
    );
};

export default Term;
